import { Badge } from "@chakra-ui/react";
import {
  PorterDeliveryTrackingStatus,
  ShipmentStatus,
} from "../types";

interface GetStatusBadgeProps {
  status: ShipmentStatus | PorterDeliveryTrackingStatus;
  size?:
    | "xx-small"
    | "x-small"
    | "small"
    | "medium"
    | "large"
    | "x-large"
    | "xx-large";
}

export const GetStatusBadge = ({
  status,
  size = "xx-small",
}: GetStatusBadgeProps) => {
  const statusConfig = {
    [ShipmentStatus.CREATED]: {
      color: "blue",
      bg: "blue.100",
      text: "blue.800",
    },
    [ShipmentStatus.REQUESTED]: {
      color: "orange",
      bg: "orange.100",
      text: "orange.800",
    },
    [ShipmentStatus.ASSIGNED]: {
      color: "purple",
      bg: "purple.100",
      text: "purple.800",
    },
    [ShipmentStatus.PICKED_UP]: {
      color: "cyan",
      bg: "cyan.100",
      text: "cyan.800",
    },
    [ShipmentStatus.IN_TRANSIT]: {
      color: "yellow",
      bg: "yellow.100",
      text: "yellow.800",
    },
    [ShipmentStatus.OUT_FOR_DELIVERY]: {
      color: "pink",
      bg: "pink.100",
      text: "pink.800",
    },
    [ShipmentStatus.DELIVERED]: {
      color: "green",
      bg: "green.100",
      text: "green.800",
    },
    [ShipmentStatus.CANCELLED]: {
      color: "red",
      bg: "red.100",
      text: "red.800",
    },
    [PorterDeliveryTrackingStatus.OPEN]: {
      color: "teal",
      bg: "teal.100",
      text: "teal.800",
    },
    [PorterDeliveryTrackingStatus.ACCEPTED]: {
      color: "blue",
      bg: "blue.100",
      text: "blue.800",
    },
    [PorterDeliveryTrackingStatus.LIVE]: {
      color: "green",
      bg: "green.100",
      text: "green.800",
    },
    [PorterDeliveryTrackingStatus.ENDED]: {
      color: "gray",
      bg: "gray.100",
      text: "gray.800",
    },
    [PorterDeliveryTrackingStatus.CANCELLED]: {
      color: "red",
      bg: "red.100",
      text: "red.800",
    },
  };

  const statusLabels = {
    // ShipmentStatus labels
    [ShipmentStatus.CREATED]: "Created",
    [ShipmentStatus.REQUESTED]: "Requested",
    [ShipmentStatus.ASSIGNED]: "Assigned",
    [ShipmentStatus.PICKED_UP]: "Picked Up",
    [ShipmentStatus.IN_TRANSIT]: "In Transit",
    [ShipmentStatus.OUT_FOR_DELIVERY]: "Out for Delivery",
    [ShipmentStatus.DELIVERED]: "Delivered",
    [ShipmentStatus.CANCELLED]: "Cancelled",
    // PorterDeliveryTrackingStatus labels
    [PorterDeliveryTrackingStatus.OPEN]: "Open",
    [PorterDeliveryTrackingStatus.ACCEPTED]: "Accepted",
    [PorterDeliveryTrackingStatus.LIVE]: "Live",
    [PorterDeliveryTrackingStatus.ENDED]: "Ended",
    [PorterDeliveryTrackingStatus.CANCELLED]: "Cancelled",
  };

  const config = statusConfig[status] || {
    color: "gray",
    bg: "gray.100",
    text: "gray.800",
  };
  const label = statusLabels[status] || status;

  return (
    <Badge
      colorScheme={config.color}
      variant="subtle"
      px={2}
      py={1}
      borderRadius="full"
      fontSize={size}
      fontWeight="medium"
    >
      {label}
    </Badge>
  );
};
